export default "__VITE_ASSET__C1p3kaw___"